// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
// Copyright (C) 2025 (original work) Open Assessment Technologies SA;
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
// Utils
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';
// Constants
import config from '@/config';

export const routing = [
    {
        path: [config.routes.scoringAssignments.home],
        guard: getPermissionsGuard([{ resource: 'portal.scoring-assignments', scopes: ['view'] }]),
        controller: () => import('./controllers/scoring-assignments.js')
    },
    {
        path: [config.routes.scoringAssignments.view],
        guard: getPermissionsGuard([{ resource: 'portal.scoring-assignments', scopes: ['view'] }]),
        controller: () => import('./controllers/scoring-assignment.js')
    }
];
